import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconSelectAllComponent } from "./med-icon-select-all.component";

@NgModule({
  declarations: [
    MedIconSelectAllComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconSelectAllComponent,
  ],
})
export class MedIconSelectAllModule { }
